import React from "react";

import { useIntl, FormattedMessage } from "react-intl";
import { useTheme } from "styled-components";

import CreateNewProject from "Components/illustrations/CreateNewProject";
import NewProjectButton from "Components/NewProjectButton";
import Button from "ds/Button";
import {
  selectEnableOrganizationFirstOnboarding,
  selectFirstProjectIncentiveEnabled
} from "Reducers/featureFlags/featureFlags.selectors";
import { organizationPaymentSourceSelector } from "Reducers/organization/paymentSource/paymentSource.selectors";
import OnboardingType from "src/organization/pages/organizationFirstOnboarding/pages/onboardingType/OnboardingType";
import { useAppSelector } from "Store/hooks";
import Illustration from "Vendor_resources/images/empty-projects.svg";
import IllustrationDark from "Vendor_resources/images/empty-projects_dark.svg";

import * as S from "./EmptyProjects.styles";

export const CreateFirstProjectText = (props: { organizationName: string }) => {
  const paymentSource = useAppSelector(state =>
    organizationPaymentSourceSelector(state, {
      organizationId: props.organizationName
    })
  );
  const isFirstProjectIncentiveEnabled = useAppSelector(
    selectFirstProjectIncentiveEnabled
  );
  const hasPaymentSource = !!paymentSource?.type;
  const createFirstProjectMessage = isFirstProjectIncentiveEnabled
    ? hasPaymentSource
      ? "create_first_project_description.paid"
      : "create_first_project_description"
    : "create_first_project_description";

  return (
    <S.EmptyProjectsListLayout className="no-projects">
      <S.ImageWrapper className="no-projects-image">
        <CreateNewProject />
      </S.ImageWrapper>
      <S.Title tag="h2">
        <FormattedMessage id="create_first_project" />
      </S.Title>
      <p>
        <FormattedMessage id={createFirstProjectMessage} />
      </p>
      <NewProjectButton organizationId={props.organizationName} />
    </S.EmptyProjectsListLayout>
  );
};

export const CreateFirstProject = (props: { organizationName: string }) => {
  const isOrganizationFirstOnboardingFlowEnabled = useAppSelector(
    selectEnableOrganizationFirstOnboarding
  );

  return isOrganizationFirstOnboardingFlowEnabled ? (
    <OnboardingType isModal={false} />
  ) : (
    <CreateFirstProjectText organizationName={props.organizationName} />
  );
};

export const EmptyFilters = (props: { resetFilters: () => void }) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <S.EmptyProjectsListLayout>
      <S.ImageWrapper>
        <img
          src={theme.name === "dark" ? IllustrationDark : Illustration}
          alt={intl.formatMessage({
            id: "billing.plan.list.empty.title"
          })}
        />
      </S.ImageWrapper>
      <S.Title tag="h2">
        <FormattedMessage id="projects_filters_empty_title" />
      </S.Title>
      <p>
        <FormattedMessage id="projects_filters_empty_description" />
      </p>
      <Button
        onClick={props.resetFilters}
        analyticId="projects_filters_empty_reset"
      >
        <FormattedMessage id="projects_filters_empty_reset" />
      </Button>
    </S.EmptyProjectsListLayout>
  );
};
